import { createEntityAdapter, createSlice, EntityState } from '@reduxjs/toolkit';

import { IComment } from 'api/digifi/los/TaskDetailsApi';
import { RootState } from 'store';

import { getTaskDetails } from './tasksSlice';

const commentsAdapter = createEntityAdapter<IComment>();

const initialState = commentsAdapter.getInitialState();

export interface ICommentsState extends EntityState<IComment> {}

const commentsSlice = createSlice({
  name: 'commentsSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getTaskDetails.fulfilled, (state, { payload }) => {
        commentsAdapter.setAll(state, payload.comments);
      });
  },
});

export const { selectEntities: selectCommentEntities } = commentsAdapter.getSelectors((state: RootState) => state.comments);

export default commentsSlice.reducer;
